/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { Component } from 'react';
import PropTypes from "prop-types";
export class EuiWindowEvent extends Component {
  componentDidMount() {
    this.addEvent(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.event !== this.props.event || prevProps.handler !== this.props.handler) {
      this.removeEvent(prevProps);
      this.addEvent(this.props);
    }
  }

  componentWillUnmount() {
    this.removeEvent(this.props);
  }

  addEvent({
    event,
    handler
  }) {
    window.addEventListener(event, handler);
  }

  removeEvent({
    event,
    handler
  }) {
    window.removeEventListener(event, handler);
  }

  render() {
    return null;
  }

}
EuiWindowEvent.propTypes = {
  event: PropTypes.any.isRequired,
  handler: PropTypes.func.isRequired
};

try {
  EuiWindowEvent.__docgenInfo = {
    description: '',
    displayName: 'EuiWindowEvent',
    methods: [],
    props: {
      event: {
        defaultValue: null,
        description: '',
        name: 'event',
        parent: {
          fileName: 'app/src/services/window_event/window_event.ts',
          name: 'Props'
        },
        required: true,
        type: {
          name: 'E'
        }
      },
      handler: {
        defaultValue: null,
        description: '',
        name: 'handler',
        parent: {
          fileName: 'app/src/services/window_event/window_event.ts',
          name: 'Props'
        },
        required: true,
        type: {
          name: '(this: Window, ev: WindowEventMap[E]) => any'
        }
      }
    },
    extendedInterfaces: ['Props']
  };
} catch (e) {}